import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Smashing = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.023 16.032c-2.508 0-4.253-1.555-4.253-1.555L4.287 17.84c1.023.547 2.092.936 2.709 1.141l-1.592.381a1.391 1.391 0 01-1.675-1.029L.639 5.405a1.39 1.39 0 011.028-1.676l3.716-.889c-.91 1.029-1.263 2.252-1.174 3.65.139 2.193 2.237 3.879 4.734 4.822 4.701 1.776 3.586 4.72 1.08 4.72zm9.338-1.438L16.27 1.666A1.388 1.388 0 0014.595.639l-2.663.637c.679.105 2.024.4 3.505 1.178l-1.159 3.213s-.965-1.078-3.553-1.209c-2.46-.125-3.828 2.537.969 4.105 3.674 1.201 4.848 3.516 4.787 5.658a5.123 5.123 0 01-.872 2.701l2.725-.652a1.39 1.39 0 001.027-1.676z"
  }));
});
Smashing.displayName = 'Smashing';
export var SmashingDimensions = {
  height: 20,
  width: 20
};